var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scroll-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "scroll-body" }, [
      _vm.recordList.length
        ? _c(
            "ul",
            { ref: "STable", staticClass: "rows" },
            _vm._l(_vm.recordList, function(record, index) {
              return _c("li", { key: index, staticClass: "row" }, [
                _c("span", { staticClass: "record-time" }, [
                  _vm._v(_vm._s(record.arrangeTime))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-content" }, [
                  _vm._v(_vm._s(record.goods_name))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-from" }, [
                  _vm._v(_vm._s(record.cityFrom))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-to" }, [
                  _vm._v(_vm._s(record.cityTo))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-weight" }, [
                  _vm._v(_vm._s(record.realTotalWeight) + " 吨")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-money" }, [
                  _vm._v(_vm._s(record.realTotalMoney) + " 元")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-phone" }, [
                  _vm._v(_vm._s(record.phone))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-status" }, [
                  _vm._v(_vm._s(record.status))
                ])
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.recordList.length
        ? _c(
            "ul",
            { staticClass: "rows_duplicate" },
            _vm._l(_vm.recordList, function(record, index) {
              return _c("li", { key: index, staticClass: "row" }, [
                _c("span", { staticClass: "record-time" }, [
                  _vm._v(_vm._s(record.arrangeTime))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-content" }, [
                  _vm._v(_vm._s(record.goods_name))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-from" }, [
                  _vm._v(_vm._s(record.cityFrom))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-to" }, [
                  _vm._v(_vm._s(record.cityTo))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-weight" }, [
                  _vm._v(_vm._s(record.realTotalWeight) + " 吨")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-money" }, [
                  _vm._v(_vm._s(record.realTotalMoney) + " 元")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-phone" }, [
                  _vm._v(_vm._s(record.phone))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "record-status" }, [
                  _vm._v(_vm._s(record.status))
                ])
              ])
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-bar" }, [
      _c("div", { staticClass: "scroll-bar-header row" }, [
        _c("span", { staticClass: "record-time" }, [_vm._v("成交时间")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-content" }, [_vm._v("成交货物")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-from" }, [_vm._v("始发地")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-to" }, [_vm._v("目的地")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-weight" }, [_vm._v("吨位")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-money" }, [_vm._v("货主价格")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-phone" }, [_vm._v("手机号码")]),
        _vm._v(" "),
        _c("span", { staticClass: "record-status" }, [_vm._v("成交状态")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-27af61de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-27af61de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/scroll-table.vue
// module id = null
// module chunks = 